/*
 * Copyright (c) CIRROM 2023.
 */

import { API } from "./api";

export const askNeo = async (
  integrated_system_id: number,
  question: string
): Promise<any> => {
  const response = await API.get("/ask-neo", {
    params: { integrated_system_id: integrated_system_id, question: question },
  });
  return response.data;
};

interface CopilotResponse {
  answer?: string;
  raw_query?: string;
  records?: unknown[];
}

export const askCopilot = async (params: {
  record_id?: number;
  suggested_change_id?: number;
  integrated_system_id: number;
  question?: string;
  predefined_question?: string;
}): Promise<CopilotResponse> => {
  const response = await API.post("/ask-copilot", params);
  return response.data;
};
